import { create } from "zustand";

// types
import { SnackbarProps } from "types/snackbar";

const initialState: SnackbarProps = {
  action: false,
  open: false,
  message: "Note archived",
  anchorOrigin: {
    vertical: "bottom",
    horizontal: "right",
  },
  variant: "default",
  alert: {
    color: "primary",
    variant: "filled",
  },
  transition: "Fade",
  close: false,
  actionButton: false,
  maxStack: 3,
  dense: false,
  iconVariant: "usedefault",
  hideIconVariant: false,
};

// ── store ──────────────────────────────────────────────────────────────────────
interface SnackbarStore {
  snackbar: SnackbarProps;
  update: (partial: Partial<SnackbarProps>) => void;
}

const useSnackbarStore = create<SnackbarStore>((set) => ({
  snackbar: initialState,
  update: (partial) =>
    set((state) => ({ snackbar: { ...state.snackbar, ...partial } })),
}));

// ── public API — same shape as before, callers unchanged ──────────────────────
export function useGetSnackbar() {
  const snackbar = useSnackbarStore((s) => s.snackbar);
  return { snackbar };
}

export function openSnackbar(snackbar: SnackbarProps) {
  useSnackbarStore.getState().update({
    action: snackbar.action ?? initialState.action,
    open: snackbar.open ?? true,
    message: snackbar.message ?? initialState.message,
    anchorOrigin: snackbar.anchorOrigin ?? initialState.anchorOrigin,
    variant: snackbar.variant ?? initialState.variant,
    alert: {
      color: snackbar.alert?.color ?? initialState.alert.color,
      variant: snackbar.alert?.variant ?? initialState.alert.variant,
    },
    transition: snackbar.transition ?? initialState.transition,
    close: snackbar.close ?? initialState.close,
    actionButton: snackbar.actionButton ?? initialState.actionButton,
  });
}

export function closeSnackbar() {
  useSnackbarStore.getState().update({ open: false });
}

export function handlerDense(dense: boolean) {
  useSnackbarStore.getState().update({ dense });
}

export function handlerIconVariants(iconVariant: string) {
  useSnackbarStore.getState().update({
    iconVariant,
    hideIconVariant: iconVariant === "hide",
  });
}

export function handlerIncrease(maxStack: number) {
  useSnackbarStore.getState().update({ maxStack });
}
